(() => {
  const bar = document.getElementById('skull-promo-top');
  if (!bar || bar.dataset.initialized) return;
  bar.dataset.initialized = 'true';
  const fields = ['days', 'hours', 'minutes', 'seconds'].map(name => bar.querySelector(`[data-promo-top-${name}]`));
  const lifecycle = new AbortController();
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const flips = new Map();
  let firstRender = true;
  function stopFlips() { [...flips.values()].forEach(cleanup => cleanup()); }
  function updateDigit(field, value) {
    const previous = field.firstChild?.textContent;
    if (previous === value) return;
    flips.get(field)?.();
    field.textContent = value;
    if (firstRender || reducedMotion.matches || document.hidden || !field.animate) return;
    // Only the changing halves turn; the readable number is always current.
    const half = (name, text) => {
      const layer = document.createElement('span');
      layer.className = `skull-promo-top__flap skull-promo-top__flap--${name}`;
      layer.setAttribute('aria-hidden', 'true');
      const face = document.createElement('span');
      face.textContent = text;
      layer.append(face); field.append(layer);
      return layer;
    };
    const base = half('base', previous);
    const top = half('top', previous);
    const bottom = half('bottom', value);
    const outgoing = top.animate([{transform:'rotateX(0deg)'},{transform:'rotateX(-90deg)'}], {duration:210,easing:'ease-in',fill:'forwards'});
    const incoming = bottom.animate([{transform:'rotateX(90deg)'},{transform:'rotateX(0deg)'}], {duration:250,delay:210,easing:'ease-out',fill:'both'});
    const cleanup = () => {
      outgoing.cancel(); incoming.cancel();
      base.remove(); top.remove(); bottom.remove();
      if (flips.get(field) === cleanup) flips.delete(field);
    };
    flips.set(field, cleanup);
    Promise.all([outgoing.finished, incoming.finished]).then(cleanup, cleanup);
  }
  reducedMotion.addEventListener('change', stopFlips, {signal:lifecycle.signal});
  document.addEventListener('visibilitychange', () => { if (document.hidden) stopFlips(); }, {signal:lifecycle.signal});
  let unsubscribe, height = -1, disposed = false;
  const layout = () => {
    const next = bar.hidden ? 0 : bar.offsetHeight;
    if (next === height) return;
    height = next;
    document.dispatchEvent(new CustomEvent('skull:promo-layout'));
  };
  const resize = new ResizeObserver(layout);
  function render(state) {
    if (disposed) return;
    if (bar.hidden !== state.expired) { bar.hidden = state.expired; layout(); }
    if (state.expired) return;
    const seconds = Math.max(0, Math.ceil(state.remainingMs / 1000));
    const values = [Math.floor(seconds / 86400), Math.floor(seconds % 86400 / 3600), Math.floor(seconds % 3600 / 60), seconds % 60];
    fields.forEach((field, index) => {
      const value = String(values[index]).padStart(2, '0');
      if (field) updateDigit(field, value);
    });
    firstRender = false;
  }
  function connect() {
    unsubscribe?.();
    unsubscribe = window.SKULL_PROMO_CLOCK?.subscribe(render);
    resize.observe(bar);
    layout();
  }
  document.addEventListener('skull:promo-clock-ready', connect, {signal:lifecycle.signal});
  if (window.SKULL_PROMO_CLOCK) connect();
  window.addEventListener('pagehide', event => {
    unsubscribe?.(); resize.disconnect(); stopFlips();
    if (!event.persisted) { disposed = true; lifecycle.abort(); }
  }, {signal:lifecycle.signal});
  window.addEventListener('pageshow', event => { if (event.persisted && !disposed) connect(); }, {signal:lifecycle.signal});
})();
